import { render } from "./PartitionMetric.vue?vue&type=template&id=4be70bf6"
import script from "./PartitionMetric.vue?vue&type=script&lang=js"
export * from "./PartitionMetric.vue?vue&type=script&lang=js"

import exportComponent from "/home/tobias/Desktop/screenads/nova-custom2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"PartitionMetric.vue"]])

export default __exports__